import React, { Component } from "react";
import { Card, Button, Select, Input, Table, Modal, message } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

import { connect } from "react-redux";
import {
  req_page_consulting,
  req_add_consulting,
  req_edit_consulting,
  req_del_consulting,
} from "../../api";

import ConsultingEdit from "./consulting-edit";
import ConsultingAdd from "./consulting-add";
import OneConsultingKeywordsModal from "./one-consulting-keywords-modal";

import { usrRole } from "../../utils/dataUtil";
import {
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";

class Consulting extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    items: [],
    item: {}, // selected
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    userLevel: "NORMAL",
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "None",
    searchValue: "",
    filterStatus: "",
    loading: false,
    isShowModal_edit_item: false,
    isShowModal_edit_keyword: false,
    isShowModal_add_item: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const { searchField, searchValue, columnSort, orderBy, filterStatus } =
      this.state;
    const { token, role, userCode } = this.props.user;

    const userLevel = usrRole(role);
    this.setState({ loading: true, userLevel: userLevel });
    const result = await req_page_consulting(
      userLevel,
      userCode,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );
    this.setState({ loading: false });
    // console.log(result)
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
  };

  api_add_item = async (row) => {
    const token = this.props.user.token;
    //console.log(row)
    const result = await req_add_consulting(row, token);
    if (result.status === "success") {
      // 1 結果提示
      message.success("新增成功");
      this.setState({ isShowModal_add_item: false });
      this.api_page_items(1);
    } else {
      console.log(result);
    }
  };

  api_edit_item = async (row) => {
    const token = this.props.user.token;
    //console.log(row)
    const result = await req_edit_consulting(row, token);
    if (result.status === "success") {
      // 1 結果提示
      message.success("編輯成功");
      this.setState({ isShowModal_edit_item: false });
      // 2 更新列表
      this.api_page_items(this.current);
    } else {
      console.log(result);
    }
  };

  api_delete_item = async (key) => {
    const { token } = this.props.user;
    const result = await req_del_consulting(key, token);

    if (result.status === "success") {
      message.success("刪除成功");
      this.api_page_items(this.current);
    } else {
      //console.log(result)
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "諮詢項目",
        dataIndex: "serviceTitle",
        width: 150,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "服務單位",
        dataIndex: "serviceDepartment",
        width: 50,
        responsive: ["md"],
      },
      {
        title: "操作",
        width: 50,
        fixed: "right",
        render: (item) => {
          return (
            <span>
              <Button
                type="dashed"
                size="small"
                style={{ color: "DarkGreen" }}
                onClick={() => this.handle_show_ui_edit_item(item)}
              >
                <i className="far fa-edit"></i> 編輯
              </Button>
              <Button
                type="dashed"
                size="small"
                style={{ color: "DarkRed" }}
                onClick={() => this.handle_show_ui_edit_keyword(item)}
              >
                <i className="fas fa-key" style={{ marginRight: "4px" }}></i>{" "}
                關鍵字
              </Button>
              <Button
                type="dashed"
                size="small"
                style={{ color: "Block" }}
                onClick={() => this.handle_delete_item(item)}
              >
                <i className="fas fa-minus" style={{ marginRight: "4px" }}></i>{" "}
                刪除
              </Button>
            </span>
          );
        },
      },
    ];
  };

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  // 操作互動處理 //////////////////////////////////////////////

  // 編輯
  handle_show_ui_edit_item = (item) => {
    //console.log(applycase)
    this.setState({ isShowModal_edit_item: true, item });
  };

  handle_edit_save_item = () => {
    const { userCode } = this.props.user;
    this.modal_form_edit_item.current
      .validateFields()
      .then((values) => {
        const {
          serviceTitle,
          serviceDescription,
          serviceDepartment,
          serviceStaffName,
          serviceTelephone,
          gid,
        } = values;
        let item = {
          serviceTitle: serviceTitle,
          serviceDescription: serviceDescription,
          serviceDepartment: serviceDepartment,
          serviceStaffName: serviceStaffName,
          serviceTelephone: serviceTelephone,
          gid: gid,
          condition: "BASE",
          recordCreator: userCode,
        };
        this.api_edit_item(item);
      })
      .catch((error) => {
        console.log(error.errorFields);
      });
  };

  // 刪除
  handle_delete_item = (item) => {
    const { gid } = item;
    Modal.confirm({
      title: "注意",
      icon: <ExclamationCircleOutlined />,
      content: "確認要刪除此諮詢項目!",
      okText: "確認",
      cancelText: "取消",
      onOk: () => {
        this.handle_process_delete_item(gid);
      },
    });
  };

  handle_process_delete_item = (gid) => {
    this.api_delete_item(gid);
  };

  // 增加
  handle_show_ui_add_item = () => {
    const { userName, userCode } = this.props.user;
    const item = {
      serviceTitle: "",
      serviceDescription: "無",
      serviceDepartment: "",
      serviceStaffName: userName,
      serviceTelephone: "",
      handlingTime: "即收即辦當日完成",
      nGoogleLocation: "0",
      applicableObjects: "所有對象",
      limitScope: "",
      recordCreator: userCode,
    };
    this.setState({ isShowModal_add_item: true, item });
  };

  handle_add_save_item = () => {
    const { recordCreator } = this.state.item;
    this.modal_form_add_item.current
      .validateFields()
      .then((values) => {
        const {
          serviceTitle,
          serviceDescription,
          serviceDepartment,
          serviceStaffName,
          serviceTelephone,
          handlingTime,
          applicableObjects,
        } = values;
        let item = {
          serviceTitle: serviceTitle,
          serviceDescription: serviceDescription,
          serviceDepartment: serviceDepartment,
          serviceStaffName: serviceStaffName,
          serviceTelephone: serviceTelephone,
          handlingTime: handlingTime,
          applicableObjects: applicableObjects,
          isHiding: "N",

          recordCreator: recordCreator,
        };
        this.api_add_item(item);
      })
      .catch((error) => {
        //console.log(error.errorFields);
      });
  };

  // 關鍵字處理
  handle_show_ui_edit_keyword = (item) => {
    //console.log(applycase)
    this.setState({ isShowModal_edit_keyword: true, item });
  };

  /////////////////////////////////////////////////////////////

  render() {
    const {
      loading,
      item,
      items,
      pagination,
      searchField,
      searchValue,
      isShowModal_add_item,
      isShowModal_edit_item,
      isShowModal_edit_keyword,
    } = this.state;
    const title = (
      <span>
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="None">搜索條件</Select.Option>
          <Select.Option value="serviceTitle">諮詢項目</Select.Option>
          <Select.Option value="serviceDepartment">服務單位</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 150, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search" style={{ marginRight: "4px" }}></i>查詢
        </Button>
      </span>
    );
    const extra = (
      <Button type="primary" onClick={() => this.handle_show_ui_add_item()}>
        <i className="fas fa-plus" style={{ marginRight: "4px" }}></i> 增加
      </Button>
    );
    return (
      <Card title={title} extra={extra}>
        <Table
          bordered
          scroll={{ y: 600 }}
          loading={loading}
          rowKey="gid"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />

        <Modal
          destroyOnClose={true}
          title="修改諮詢項目"
          visible={isShowModal_edit_item}
          onOk={this.handle_edit_save_item}
          onCancel={() => {
            this.setState({ isShowModal_edit_item: false });
          }}
        >
          <ConsultingEdit
            modalform={(form) => (this.modal_form_edit_item = form)}
            item={item}
          />
        </Modal>
        <Modal
          destroyOnClose={true}
          title="增加諮詢項目"
          visible={isShowModal_add_item}
          onOk={this.handle_add_save_item}
          onCancel={() => {
            this.setState({ isShowModal_add_item: false });
          }}
        >
          <ConsultingAdd
            modalform={(form) => (this.modal_form_add_item = form)}
            item={item}
          />
        </Modal>

        <Modal
          destroyOnClose={true}
          title="增刪關鍵字"
          visible={isShowModal_edit_keyword}
          onOk={() => {
            this.setState({ isShowModal_edit_keyword: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <OneConsultingKeywordsModal item={item} />
        </Modal>
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(Consulting);
